import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/* eslint-disable @typescript-eslint/no-explicit-any */
// Validator to check if two fields match
// Must add to at least two controls in order to be able to compare
export function mustMatchValidator(matchTo: string, reverse?: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.parent && reverse) {
            const c = (control.parent?.controls as any)[matchTo] as AbstractControl;
            if (c) {
                c.updateValueAndValidity();
            }
            return null;
        }
        return !!control.parent &&
            !!control.parent.value &&
            control.value === (control.parent?.controls as any)[matchTo].value
            ? null
            : { matching: true };
    };
}
